import { Component, OnInit, Input, NgZone } from '@angular/core';
import { base64StringToBlob } from 'blob-util';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { GeneralService } from '../services/general.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ListeActionDialigComponent } from '../liste-action-dialig/liste-action-dialig.component';
import * as globalUrls from '../services/globalVariables';

declare var $: any;
@Component({
  selector: 'app-show-tree-doc',
  templateUrl: './show-tree-doc.component.html',
  styleUrls: ['./show-tree-doc.component.scss'],
})
export class ShowTreeDocComponent implements OnInit {
  constructor(
    public ngZone: NgZone,
    public dialog: MatDialog,
    public http: HttpClient,
    public generalService: GeneralService
  ) {}
  listePdfBase64 = [];
  postUrl = '...';
  myFormData: FormData; //populated by ngfFormData directive
  httpEvent: HttpEvent<any>;
  treeDoc = [
    // {
    //   "text" : "Document Collaborateur",
    //   "id" : 10000000,
    //   "icon" : "jstree-folder"
    // }
  ];
  showDoc = false;
  static selectedNode;
  IdNodeSelected = null;
  clickMode;
  exist = true;
  docBrut;
  curentId = '20000000';
  myDoc;
  initDoc;
  buttonDisabled = false;
  @Input() typeTrs = '1';
  @Input() param_code;
  // pour identifier le type sur qu'elle module en travaille: collaborateur, action,...
  @Input() File_Type = '';
  // pour identifier le type de ficher :cv , fiches de paie,contrat...
  @Input() File_Groupe = '';
  @Input() showAllDocument = true;
  @Input() File_Lien = '';
  ngOnInit() {
    this.getDocument(true);
    if (this.typeTrs == '3') this.buttonDisabled = true;
  }
  onChangefileToUpload(fileInput) {
    var reader2 = new FileReader();
    var src: string;
    reader2.onload = (e) => {
      src = reader2.result.toString();
      var imageName = fileInput.target.files[0].name;
      var imageType = src.substring(0, src.indexOf(',') + 1);
      var imageSrc = src.replace(imageType, '');

      var parent = '';
      if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
        parent = this.IdNodeSelected;
      }
      this.addFiles(
        this.generalService.initDoc,
        imageSrc,
        imageName,
        this.param_code,
        this.File_Type,
        parent,
        this.clickMode,
        this.File_Groupe,
        this.File_Lien,
        imageType
      );
    };
    reader2.readAsDataURL(fileInput.target.files[0]);
  }

  initTree(addEvent) {
    $('#documentColl').jstree({
      //"plugins" : ["checkbox" ],
      themes: { stripes: true },
      animation: 0,
      core: {
        strings: {
          'New node': ' ',
        },
        check_callback: (operation, node, parent, position, more) => {
          if (operation === 'copy_node' || operation === 'move_node') {
            if (parent.id === '#') {
              return false;
            }
          } else if (operation === 'create_node') {
            //node.icon = "jstree-file";
            //node.id = this.curentId;
            var myNode = $('#documentColl').jstree(true)._model.data[parent.id];
            myNode.icon = true;
          }
          return true;
        },
      },
    });
    $('#documentColl').jstree(true).settings.core.data = this.treeDoc;
    $('#documentColl').jstree(true).refresh();
    if (addEvent) this.addEventTree();
  }
  async openDoc() {
    var node = $('#documentColl').jstree(true).get_node(this.IdNodeSelected);
    if (node.icon == 'jstree-file') {
      if (this.generalService.isNotEmpty(this.IdNodeSelected)) {
        this.exist = false;
        const b64Data = await this.generalService
          .rechercheTable(globalUrls.urlFiles + '&val=' + this.IdNodeSelected)
          .toPromise();
        const contentType = b64Data.Files[0].File_Autre.substring(
          b64Data.Files[0].File_Autre.indexOf(':') + 1,
          b64Data.Files[0].File_Autre.indexOf(';')
        ); // 'image/png' data:application/pdf;base64 application/pdf
        const blob = base64StringToBlob(
          b64Data.Files[0].File_Content,
          contentType
        );
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, b64Data.Files[0].File_Text);
          this.exist = true;
        } else {
          var fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
          this.exist = true;
        }
      } else {
        this.generalService.dialogSuccess(
          'veuillez sélectionner un element',
          false
        );
      }
    } else
      this.generalService.dialogSuccess(
        'Uniquement les fichiers peuvent être ouvert',
        false
      );
  }
  // addFile est la meme que la fontion addFile de generale servive sauf-qu'il appelle la fonction this.getDocument(false);
  addFiles(
    initDoc,
    File_Content,
    File_Text,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien,
    File_Autre
  ) {
    this.exist = false;
    var doc = this.generalService.clone(initDoc);
    if (clickMode != 'renommer') {
      doc.files[0].File_Parent = File_Parent;
      doc.files[0].File_Content = File_Content;
      doc.files[0].File_Text = File_Text;
      doc.files[0].File_Key = File_Key;
      doc.files[0].File_Type = File_Type;
      doc.files[0].File_Groupe = File_Groupe;
      doc.files[0].File_Lien = File_Lien;
      if (this.generalService.isNotEmpty(File_Autre))
        doc.files[0].File_Autre = File_Autre;
      if (clickMode == 'crerFichier') {
        doc.files[0].File_Dll = 'jstree-file';
      }
      if (clickMode == 'crerDossier') {
        doc.files[0].File_Dll = 'jstree-folder';
      }
      this.generalService.enregisterTable(doc).subscribe(
        (data) => {
          this.getDocument(false);
          this.generalService.dialogSuccess('Document enregistré', true);
        },
        (err) => {
          this.generalService.dialogSuccess('Document non enregisté', false);
        }
      );
    }
  }
  editFiles(node) {
    this.generalService
      .rechercheTable(globalUrls.urlFiles + '&val=' + node.a_attr.myId)
      .subscribe((file) => {
        file.Files[0].File_Text = node.text;
        file.Files[0].File_Lien = node.a_attr.File_Lien;
        this.generalService.enregisterTable(file).subscribe((data) => {
          this.generalService.dialogSuccess("L'opération est réussie", true);
          this.exist = true;
        });
      });
  }
  addEventTree() {
    if (!this.buttonDisabled) {
      $('#documentColl').on('dblclick.jstre', (e) => {
        var node = $(e.target).closest('li');
        var type = node.attr('rel');
        var item = node[0].id;
        this.IdNodeSelected = item;
        this.openDoc();
      });
      $('#documentColl').on('select_node.jstree', (e, data) => {
        if (this.IdNodeSelected == data.selected[0]) {
          data.instance.deselect_node(data.node);
          this.IdNodeSelected = null;
          this.File_Groupe = '';
        } else {
          var myNode = data.selected[0];
          this.IdNodeSelected = data.node.a_attr.myId;
          this.File_Groupe = data.node.a_attr.groupe;
        }

        // console.log(ChildrenNodes);
      });
      $('#documentColl').on('rename_node.jstree', (e, data) => {
        if (data.text != ' ' && data.text != '') {
          if (this.clickMode == 'crerDossier')
            if (this.IdNodeSelected != null)
              this.addFiles(
                this.generalService.initDoc,
                '',
                data.node.text,
                this.param_code,
                this.File_Type,
                this.IdNodeSelected,
                this.clickMode,
                this.File_Groupe,
                this.File_Lien,
                null
              );
            else
              this.addFiles(
                this.generalService.initDoc,
                '',
                data.node.text,
                this.param_code,
                this.File_Type,
                '',
                this.clickMode,
                this.File_Groupe,
                this.File_Lien,
                null
              );
          else this.editFiles(data.node);
        } else {
          var MyTree = $('#documentColl').jstree(true);
          MyTree.delete_node(data.node);
        }
      });
    }

    $('#documentColl').on('ready.jstree', (e, data) => {
      var id = 0;
      var theTree = data.instance._model.data;
      var count = 0;
      for (var prop in theTree) {
        if (theTree[prop].parent == '#') id = theTree[prop].id;
      }
      $('#documentColl').jstree('open_node', $('#' + id));
    });
  }
  //elle doit retourne le dernier id du tree (select max(id) as maxId from treeTable)
  getNextId() {
    var listId = this.docBrut.map((t) => parseInt(t.File_Id));
    var max = listId.reduce(function (a, b) {
      return Math.max(a, b);
    });
    return max + 1;
  }
  getChildrenId(id: Number) {
    var list = this.treeDoc.filter((node) => {
      return node.parent == id;
    });
    return list;
  }
  getNodeById(id) {
    var myNode = this.docBrut.find((node) => {
      return node.File_Id == id;
    });
    return myNode;
  }
  getParentNode(tree) {
    var myNode = tree.filter((node) => {
      return node.File_Parent == null;
    });
    return myNode;
  }
  getDocument(addEvent) {
    var url = '';
    if (this.showAllDocument)
      url = globalUrls.urlListeDocColl + this.param_code + ',' + this.File_Type;
    else {
      if (this.File_Lien == '') {
        if (this.param_code != '')
          url =
            globalUrls.urlListeFilesR +
            this.param_code +
            ',' +
            this.File_Groupe +
            ',' +
            this.File_Type;
        else
          url =
            globalUrls.urlListeFilesR2 +
            this.File_Groupe +
            ',' +
            this.File_Type;
      } else
        url =
          globalUrls.urlListeFilesAction +
          this.File_Groupe +
          ',' +
          this.File_Type +
          ',' +
          this.File_Lien;
    }
    this.exist = false;
    this.generalService.rechercheTable(url).subscribe((data) => {
      this.docBrut = data;
      //les ressource pedagogique et les enquette de satisfaction vient
      //plisieur dossier, et ne peux etre afficher que apret avoir mettre  File_Parent à null
      if (this.File_Lien != '') {
        this.docBrut.forEach((doc) => {
          doc.File_Parent = null;
        });
      }
      this.treeDoc = this.generalService.generateTreeData(this.docBrut);
      this.initTree(addEvent);
      this.showDoc = true;
      this.exist = true;
    });
  }
  crerDossier() {
    this.clickMode = 'crerDossier';
    if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
      // var node = $('#documentColl').jstree(true).get_node(this.IdNodeSelected);
      var node = this.getNodeById(this.IdNodeSelected);
      if (node.File_Dll == 'jstree-folder') {
        var MyTree = $('#documentColl').jstree(true);
        var idNode = MyTree.create_node(this.IdNodeSelected, { text: ' ' });
        MyTree.edit(idNode);
      } else
        this.generalService.dialogSuccess(
          'vous ne pouvez pas créer un element sous un fichier',
          false
        );
    } else {
      if (this.treeDoc.length == 0) {
        var MyTree = $('#documentColl').jstree(true);
        var id = MyTree.create_node(null, {
          children: [],
          children_d: [],
          data: null,
          icon: true,
          a_attr: { myId: null },
          original: {
            text: 'Nouveau dossier',
            icon: 'jstree-folder',
            a_attr: { myId: null },
          },
          parent: null,
          parents: ['#'],
          state: {
            loaded: true,
            opened: true,
            selected: true,
            disabled: false,
          },
          text: 'Nouveau dossier',
        });
        MyTree.edit(id);
      } else {
        var MyTree = $('#documentColl').jstree(true);
        var id = MyTree.create_node('#', {
          children: [],
          children_d: [],
          data: null,
          icon: true,
          a_attr: { myId: null },
          original: {
            text: 'Nouveau dossier',
            icon: 'jstree-folder',
            a_attr: { myId: null },
          },
          parent: '#',
          parents: ['#'],
          state: {
            loaded: true,
            opened: true,
            selected: true,
            disabled: false,
          },
          text: 'Nouveau dossier',
        });
        MyTree.edit(id);
      }
    }
  }
  crerFichier() {
    if (this.generalService.isNotEmpty(this.IdNodeSelected)) {
      var node = this.getNodeById(this.IdNodeSelected);
      if (node.File_Dll != 'jstree-folder') {
        this.generalService.dialogSuccess(
          'vous ne pouvez pas créer un element sous un fichier',
          false
        );
        return;
      }
    }
    this.clickMode = 'crerFichier';
    document.getElementById('fileToUpload').click();
  }
  renommer() {
    if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
      this.clickMode = 'renommer';
      var MyTree = $('#documentColl').jstree(true);
      MyTree.edit(this.IdNodeSelected);
    } else {
      this.generalService.dialogSuccess(
        'veuillez sélectionner un element',
        false
      );
    }
  }
  async telecharger() {
    if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
      var node = $('#documentColl').jstree(true).get_node(this.IdNodeSelected);
      if (node.icon == 'jstree-file') {
        const contentType = 'application/pdf';
        const b64Data = await this.generalService
          .rechercheTable(globalUrls.urlFiles + '&val=' + this.IdNodeSelected)
          .toPromise();
        const blob = base64StringToBlob(
          b64Data.Files[0].File_Content,
          contentType
        );
        var fileURL = URL.createObjectURL(blob);
        window.URL.revokeObjectURL(fileURL);
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, node.text);
          return;
        }
        const blobURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', node.text);
        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
        }
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        // For Firefox it is necessary to delay revoking the ObjectURL
        setTimeout(() => {
          window.URL.revokeObjectURL(blobURL);
        }, 100);
      }
    } else {
      this.generalService.dialogSuccess(
        'veuillez sélectionner un element',
        false
      );
    }
  }
  supprimer() {
    if (this.generalService.isNotEmpty(this.IdNodeSelected)) {
      if (confirm('Voulez-vous supprimer cet élément ?')) {
        /* si on clique sur ok */
        var MyTree = $('#documentColl').jstree(true);
        var node = MyTree.get_node(this.IdNodeSelected);
        var initData = Object.values(MyTree._model.data);

        MyTree.delete_node(node);
        var data = Object.values(MyTree._model.data);
        var dataToDelet = [];
        initData.forEach((initD) => {
          var find = data.find((d) => {
            return d['id'] == initD['id'];
          });
          if (find == undefined) {
            this.generalService
              .supprimerSanMsgConfirm(initD['id'], 'avtFiles')
              .subscribe(
                (data) => {
                  this.generalService.dialogSuccess('Elément supprimer', true);
                  // this.getDocument(false);
                },
                (error) => {
                  this.generalService.dialogSuccess(
                    'Elément non supprimé',
                    false
                  );
                }
              );
          }
        });
        this.IdNodeSelected = null;
      }
    } else {
      this.generalService.dialogSuccess(
        'veuillez sélectionner un element',
        false
      );
    }
  }
  attacherAction() {
    if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
      var node = $('#documentColl').jstree(true).get_node(this.IdNodeSelected);
      // groupe == 3 ou 4 -> un dossier ressouce ou enquette de satisfaction
      if (node.a_attr.groupe == '3' || node.a_attr.groupe == '4') {
        this.exist = false;
        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        // dialogConfig.width = "50%";
        // dialogConfig.height = "80%";
        dialogConfig.data = { id: this.IdNodeSelected };
        this.ngZone
          .run(() => this.dialog.open(ListeActionDialigComponent, dialogConfig))
          .afterClosed();
        var dialogRef = this.dialog.open(
          ListeActionDialigComponent,
          dialogConfig
        );

        dialogRef.afterClosed().subscribe((avtAction_Code) => {
          if (
            avtAction_Code != undefined &&
            avtAction_Code != null &&
            avtAction_Code != ''
          ) {
            node.a_attr.File_Lien = avtAction_Code;
            this.editFiles(node);
          } else this.exist = true;
        });
      } else {
        this.generalService.dialogSuccess(
          'veuillez sélectionner un element de dossier ressource pédagogique ou enquête de satisfaction  ',
          false
        );
      }
    } else {
      this.generalService.dialogSuccess(
        'veuillez sélectionner un element',
        false
      );
    }
  }
  setIconTree() {
    this.treeDoc.forEach((doc) => {
      var childrens = this.getChildrenId(doc.a_attr.myId);
      if (childrens.length == 0) {
        doc['icon'] = 'jstree-file';
      }
    });
  }
}
